var map = {
	"./alianzas-inversion.mp4": 1550,
	"./avatar-santiago-scn3.mp4": 7288,
	"./avatar-santiago-scn4.mp4": 1303,
	"./fase-final.mp4": 9205,
	"./juan-consulta.mp4": 1810,
	"./juan-hospital.mp4": 3201,
	"./juan-salon.mp4": 5679,
	"./locucion-blue.mp4": 1355,
	"./locucion-green.mp4": 7898,
	"./locucion-red.mp4": 296,
	"./locucion-violet-1.mp4": 4,
	"./locucion-violet-2.mp4": 5138,
	"./mute-blue.mp4": 8172,
	"./mute-green.mp4": 7375,
	"./mute-orange.mp4": 1138,
	"./mute-red.mp4": 7693,
	"./mute-violet.mp4": 635,
	"./paciente-1.mp4": 9195,
	"./presentacion-planeta.mp4": 8842,
	"./reglas-1.mp4": 5476,
	"./reglas-2.mp4": 5926,
	"./reglas-3.mp4": 9044,
	"./resumen-clinico-ant.mp4": 5187,
	"./resumen-clinico.mp4": 3118,
	"./revisad-datos-clave.mp4": 6230,
	"./santiago-fin.mp4": 2441,
	"./sin-sonido.mp4": 6563,
	"./timeup.mp4": 2491
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2772;